import React from "react";
import { ModalDialog } from "../../../../components";
import { connect } from "react-redux";
import { cancelPurchaseAndHideLockedOrderModal } from "../../../../../js/actions/generalActions";

const LockedOrderModal: React.FC = () => {
    function cancelPurchaseClicked(e: React.MouseEvent<HTMLButtonElement>) {
        if (e) e.preventDefault();
        // TODO It does happen at this point that there is no purchaseId cookie
        // Perhaps because we managed to call initiatePurchase but something happened
        // that prevented it from finishing and setting the cookie *on our side*
        cancelPurchaseAndHideLockedOrderModal();
    }

    return (
        <ModalDialog
            size="medium"
            submitText="Gå tilbake til kassen"
            closeText="Fortsette å handle mer"
            heading="Ups, der skjedde det noe..."
            name="locked-order-modal"
            onSubmit={() => {
                window.location.href = "/kasse/oppsummering/";
            }}
            onClose={cancelPurchaseClicked}
        >
            Det kan se ut som du allerede var på god vei i bestillingen din. Vil du fortsette å handle mer, eller gå
            tilbake til kassen?
        </ModalDialog>
    );
};

export default connect(null, {
    cancelPurchaseAndHideLockedOrderModal,
})(LockedOrderModal);
